import { icon, Icon } from '../lib/fa-icons.js';
import $ from "jquery";
import Widget from "./base.js";
import Keypress from "keypress.js";
import DataFetcher from "../sheets-data-fetcher.js";

//https://docs.google.com/spreadsheets/d/1muiQMIIZEj14d_2C-KJhYoZP6opRTJTlTQkmxPRWHUE/edit#gid=0
export class RoeBase extends Widget {
	componentDidMount() {
		this.sheetID = "1muiQMIIZEj14d_2C-KJhYoZP6opRTJTlTQkmxPRWHUE";
		const self = this;

		DataFetcher._emitter.on("response", (data) => {
			if (data.values) {
				let values = data.values;
				self.getColIndices(values[0]);
				//handleData defined on child components, different in each case
				self.handleData(values, self.countGroups(values));
			} else {
				self.setState({ error: true });
			}
		});

		if (!DataFetcher[`data-${this.sheetID}`]) DataFetcher.fetch(this.sheetID);
	}

	getColIndices(head) {
		let obj = {};
		head.forEach((element, index) => {
			obj[element] = index;
		});
		this.indices = obj;
	}

	getCell(row, colName) {
		return row[this.indices[colName]];
	}

	countGroups(data) {
		let yes = 0;
		let keepingItVague = 0;
		let noComment = 0;
		let problemChildren = 0;
		let knownNos = 0;

		data.forEach((row, index) => {
			let group = this.getCell(row, "Group");
			if (group === "Yes") {
				yes++;
			} else if (group === "Keeping It Vague") {
				keepingItVague++;
			} else if (group === "No Comment") {
				noComment++;
			} else if (group === "Problem Children") {
				problemChildren++;
			} else if (group === "Known Nos") {
				knownNos++;
			}
		});

		const groups = {
			yes: yes,
			keepingItVague: keepingItVague,
			noComment: noComment,
			problemChildren: problemChildren,
			knownNos: knownNos,
		};
		return groups;
	}
}

export class RoeMeter extends RoeBase {
	handleData(data, groups) {
		this.setState({
			groups: groups,
			data: data,
		});
	}

	heading() {
		return (
			<div className="RoeMeter__Heading">
				<div>
					“Roe and Reform” means voting to pass legislation to codify Roe’s
					protections as federal law and committing to suspend or reform the
					filibuster rules to guarantee that bill gets an up or down majority
					vote.
				</div>
				<b>Here’s where every senator stands.</b>
			</div>
		);
	}

	mouseEnter(letter) {
		this.setState({ isMouseInside: letter });
	}

	mouseLeave() {
		this.setState({ isMouseInside: false });
	}

	dots() {
		return (
			<div className="RoeMeter__Dots">
				<div
					className="RoeMeter__Dot"
					onMouseEnter={() => {
						this.mouseEnter("a");
					}}
					onMouseLeave={() => {
						this.mouseLeave();
					}}
				>
					<div className="RoeMeter__DotLetter --a">A</div>
					<div className="RoeMeter__DotGroup">The Yes Crowd</div>
				</div>
				<div
					className="RoeMeter__Dot"
					onMouseEnter={() => {
						this.mouseEnter("b");
					}}
					onMouseLeave={() => {
						this.mouseLeave();
					}}
				>
					<div className="RoeMeter__DotLetter --b">B</div>
					<div className="RoeMeter__DotGroup">Keeping It Vague</div>
				</div>
				<div
					className="RoeMeter__Dot"
					onMouseEnter={() => {
						this.mouseEnter("c");
					}}
					onMouseLeave={() => {
						this.mouseLeave();
					}}
				>
					<div className="RoeMeter__DotLetter --c">C</div>
					<div className="RoeMeter__DotGroup">No Comment</div>
				</div>
				<div
					className="RoeMeter__Dot"
					onMouseEnter={() => {
						this.mouseEnter("d");
					}}
					onMouseLeave={() => {
						this.mouseLeave();
					}}
				>
					<div className="RoeMeter__DotLetter --d">D</div>
					<div className="RoeMeter__DotGroup">Problem Children</div>
				</div>
				<div
					className="RoeMeter__Dot"
					onMouseEnter={() => {
						this.mouseEnter("f");
					}}
					onMouseLeave={() => {
						this.mouseLeave();
					}}
				>
					<div className="RoeMeter__DotLetter --f">F</div>
					<div className="RoeMeter__DotGroup">Known Nos</div>
				</div>
			</div>
		);
	}

	renderContent() {
		if (this.state.error)
			return <div class="RoeMeter__Inner --empty">error fetching data</div>;
		if (!this.state.groups)
			return <div class="RoeMeter__Inner --empty">...fetching...</div>;
		else {
			const groups = this.state.groups;
			return [
				this.heading(),
				this.dots(),
				<div className={`RoeMeter__Inner ${this.props.embed ? "--embed" : ""}`}>
					<div
						className={`RoeMeter__Section --yes `}
						style={`width: ${(groups.yes / 50) * 100}%`}
					>
						<div
							className={`RoeMeter__SectionFill --yes ${
								this.state.isMouseInside === "a" ? "--highlight" : ""
							}`}
						>
							{groups.yes}
						</div>
					</div>
					<div
						className={`RoeMeter__Section --keepingItVague `}
						style={`width: ${(groups.keepingItVague / 50) * 100}%`}
					>
						<div
							className={`RoeMeter__SectionFill --keepingItVague ${
								this.state.isMouseInside === "b" ? "--highlight" : ""
							}`}
						>
							{groups.keepingItVague}
						</div>
					</div>
					<div
						className={`RoeMeter__Section --noComment`}
						style={`width: ${(groups.noComment / 50) * 100}%`}
					>
						<div
							className={`RoeMeter__SectionFill --noComment ${
								this.state.isMouseInside === "c" ? "--highlight" : ""
							}`}
						>
							{groups.noComment}
						</div>
					</div>
					<div
						className={`RoeMeter__Section --problemChildren`}
						style={`width: ${(groups.problemChildren / 50) * 100}%`}
					>
						<div
							className={`RoeMeter__SectionFill --problemChildren ${
								this.state.isMouseInside === "d" ? "--highlight" : ""
							}`}
						>
							{groups.problemChildren}
						</div>
					</div>

					<div
						className={`RoeMeter__Section --knownNos`}
						style={`width: ${(groups.knownNos / 50) * 100}%`}
					>
						<div
							className={`RoeMeter__SectionFill --knownNos  ${
								this.state.isMouseInside === "f" ? "--highlight" : ""
							}`}
						>
							{groups.knownNos}
						</div>
					</div>
				</div>,
			];
		}
	}
}

export class RoeTable extends RoeBase {
	handleData(data, groups) {
		data.shift();
		this.setState({ data: data }, this.setupDataTable);
	}

	componentWillMount() {
		this.keypress = new Keypress.Listener();

		this.keypress.register_combo({
			keys: "esc",
			// is_solitary: true,
			is_exclusive: true,
			is_unordered: true,
			on_keyup: (evt) => {
				this.hideTooltips();
			},
		});
	}

	setupDataTable() {
		$("#RoeTable").DataTable({
			paging: false,
			searching: true,
			order: [[0, "asc"]],
			info: false,
			stripeClasses: [], //disable stripes
			columnDefs: [{ targets: "no-sort", orderable: false }],
			initComplete: function () {
				this.api()
					.columns([2])
					.every(function () {
						var column = this;
						var select = $('<select><option value="">All</option></select>')
							.appendTo($(column.header()))
							.on("change", function () {
								//clear prev searches
								// $('#RoeTable')
								//   .DataTable()
								//   .columns()
								//   .every(function () {
								//     var thisCol = this
								//     thisCol.search('').draw()
								//   })
								//do this search
								var val = $.fn.dataTable.util.escapeRegex($(this).val());
								column.search(val ? "^" + val + "$" : "", true, false).draw();
							})
							.on("click", function (e) {
								e.stopPropagation();
							});

						column
							.data()
							.unique()
							.sort()
							.each(function (d, j) {
								select.append('<option value="' + d + '">' + d + "</option>");
							});
					});
			},
		});
	}

	toggleTooltip(tip, row) {
		this.hideTooltips();

		const tableOffset = $("#RoeTable_wrapper table tbody").offset().top;

		const $row = $("#" + row);
		const rowOffset = $row.offset().top + $row.height();

		const diff = Math.abs(rowOffset - tableOffset);

		$("#" + tip).css("top", diff + "px");

		// const parentTop = parentElem.getBoundingClientRect().top //  parent's top distance from the top of the viewport;
		// const currentChildTop = childElement.getBoundingClientRect().top //  child's top distance from the top of the viewport;

		//cant use react state, dont wanna re-render
		if (!this.active) {
			this.active = tip;
			$("#" + tip).addClass("--active");
		} else {
			this.active = null;
			$("#" + tip).removeClass("--active");
		}
	}

	hideTooltips() {
		// if (evt.target.classList.contains('RoeTable__TooltipControl')) return
		// if (evt.target.classList.contains('RoeTable__Tooltip')) return

		this.active = null;
		$(".RoeTable__Tooltip").each(function () {
			$(this).removeClass("--active");
		});
	}

	renderTableRows() {
		let tableRows = [];
		this.state.data.forEach((row, index) => {
			const sortName =
				this.getCell(row, "Last") + "-" + this.getCell(row, "First");
			//get the "what they said" text formatted
			//$$ delimits start of each quote item
			let quotes = [];
			let said = this.getCell(row, "Details & Sourcing");
			if (!!said) {
				said = said.split("$$");
				quotes = said.map((quote) => {
					if (quote.length < 1) return;
					if (quote.indexOf("~") < 1) return <p>{quote}</p>;
					//tilde delimits start of link for quote s
					const parts = quote.split("~");

					let text = parts[0];
					let textArr = text.split("/n");
					if (textArr.length > 1) {
						const printText = (text) => {
							return text.map((line, i) => {
								if (text.length === i + 1) return line;
								return [line, <div style="height: 0.25em"></div>];
							});
						};
						text = printText(textArr);
					} else {
						text = parts[0];
					}

					const date = parts[1];
					const href = parts[2];
					return (
						<p>
							{text}
							<a href={href} target="_blank">
								{date}
								<Icon name="up-right-from-square" style="regular" />
							</a>
						</p>
					);
				});
			}

			//generate classes & sorting ranks for group column
			let group = this.getCell(row, "Group");
			let groupClass = group.split(" ").join("");

			let sortPos;
			let letter;
			switch (group) {
				case "Yes":
					sortPos = 1;
					letter = "A";
					break;
				case "Keeping It Vague":
					sortPos = 2;
					letter = "B";

					break;
				case "No Comment":
					sortPos = 3;
					letter = "C";

					break;
				case "Problem Children":
					sortPos = 4;
					letter = "D";

					break;
				case "Known Nos":
					sortPos = 5;
					letter = "F";
					break;
				default:
					break;
			}

			//image filename
			let filename =
				this.getCell(row, "First") + "-" + this.getCell(row, "Last") + ".jpg";
			filename = filename.replace(" ", "");
			tableRows.push(
				<tr id={`row${index}`}>
					<td data-sort={sortName} class="name">
						{this.getCell(row, "First")} {this.getCell(row, "Last")} (
						{this.getCell(row, "Party")}-{this.getCell(row, "State")})
					</td>
					<td data-sort={sortPos}>
						<div class={`RoeTable__GroupDot --${groupClass}`}>{letter}</div>
					</td>
					<td
						class={(
							this.getCell(row, 'Position on "Roe and Reform"') || ""
						).replace(" ", "")}
					>
						{this.getCell(row, 'Position on "Roe and Reform"')}
					</td>

					<td class="details">
						<div
							class="RoeTable__TooltipControl"
							onclick={() => {
								this.toggleTooltip("tip" + index, "row" + index);
							}}
						>
							What they said <Icon name="chevron-down" style="light" />
						</div>
					</td>
					<div id={`tip${index}`} class="RoeTable__Tooltip">
						<div class="RoeTable__TooltipInner">
							<div
								class="RoeTable__TooltipClose"
								onClick={(evt) => {
									this.hideTooltips(evt);
								}}
							>
								<Icon name="xmark" style="light" />
							</div>
							<img
								class="RoeTable__TooltipImg"
								src={`/wp-content/themes/tpm25/assets/images/filibuster-headshots/${filename}`}
								alt={this.getCell(row, "Name")}
							/>
							<div class="RoeTable__TooltipText">{quotes}</div>
						</div>
					</div>
				</tr>
			);
		});
		return tableRows;
	}

	renderContent() {
		if (!this.state.data) return;
		return (
			<table id="RoeTable" class="hover">
				<thead>
					<tr>
						<th class="name">
							<div>
								Name
								{/* <Icon name="sort" style="solid" />
                <Icon name="sort-up" style="solid" />
                <Icon name="sort-down" style="solid" /> */}
							</div>
						</th>
						<th class="group">
							<div>Group</div>
						</th>
						<th class="no-sort">
							<div>Position on "Roe and Reform"</div>
						</th>
						<th class="no-sort details">Details &amp; Sourcing</th>
					</tr>
				</thead>
				<tbody>{this.renderTableRows()}</tbody>
				<tfoot>
					<tr>
						<td class="name"></td>
						<td></td>
						<td></td>
						<td class="details"></td>
					</tr>
				</tfoot>
			</table>
		);
	}
}
